import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import React, { useEffect, useRef } from 'react'

interface RichTextEditorProps {
  value?: string
  setText: (text: string) => void
  toolbarId: string
  editorId: string
  type: string
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  setText,
  toolbarId,
  editorId,
  type,
}) => {
  const editorRef = useRef<HTMLDivElement | null>(null)
  const quillRef = useRef<Quill | null>(null)

  useEffect(() => {
    if (!editorRef.current) return

    quillRef.current = new Quill(editorRef.current, {
      theme: 'snow',
      modules: {
        toolbar: `#${toolbarId}`,
      },
      formats: [
        'bold',
        'color',
        'font',
        'code',
        'italic',
        'link',
        'size',
        'strike',
        'underline',
        'blockquote',
        'header',
        'indent',
        'list',
        'align',
        'direction',
        'formula',
      ],
    })

    quillRef.current.on('text-change', () => {
      const html = quillRef.current?.root.innerHTML || ''
      setText(html)
    })

    if (value) {
      quillRef.current.root.innerHTML = value
    }

    return () => {
      quillRef.current = null
    }
  }, [toolbarId])

  useEffect(() => {
    if (quillRef.current && value !== quillRef.current.root.innerHTML) {
      quillRef.current.root.innerHTML = value || ''
    }
  }, [value])

  return (
    <div
      className={`mb-10 text-text_color ${type === 'Abstract' ? 'h-[100px]' : 'h-[300px]'} `}
    >
      <div id={toolbarId} className="rounded-t-[5px]">
        <span className="ql-formats">
          <select className="ql-header">
            <option value="1">Heading 1</option>
            <option value="2">Heading 2</option>
            <option value="3">Heading 3</option>
            <option value="4">Heading 4</option>
            <option value="5">Heading 5</option>
            <option value="6">Heading 6</option>
            <option value="">Normal</option>
          </select>
        </span>
        <span className="ql-formats">
          <button className="ql-bold"></button>
          <button className="ql-italic"></button>
          <button className="ql-underline"></button>
          <button className="ql-strike"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-align" value=""></button>
          <button className="ql-align" value="center"></button>
          <button className="ql-align" value="right"></button>
          <button className="ql-align" value="justify"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-link"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-script" value="sub"></button>
          <button className="ql-script" value="super"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-clean"></button>
        </span>
      </div>
      <div
        id={editorId}
        ref={editorRef}
        className="mb-10 h-[200px] rounded-b-[5px]"
      ></div>
    </div>
  )
}

export default RichTextEditor
